import React, { Component } from "react";

import { Button, Modal } from "antd";
import { Tabs } from "antd";
import { message } from "antd";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import instance from "@/store/actions/instance";
import ProductionOrderInvoice from "./ProductionOrderInvoice";

const { TabPane } = Tabs;
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

class ProductionOrderDetailsModal extends Component {
  state = {
    loading: true,
    products: [],
    editMode: false,
    originalProducts: [],
  };
  fetchProductionOrderDetails = async () => {
    const { t, selectedOrder } = this.props;
    try {
      const res = await instance.get(
        `get_production_orders/${selectedOrder.id}`,
      );

      this.setState({
        loading: false,
        products: res.data,
        originalProducts: JSON.parse(JSON.stringify(res.data)),
      });
    } catch (err) {
      if (err.response && err.response.status == 403)
        message.error(t("AccessDeniedMessage"));
      else message.error(t("SomethingWentWrong"));
    }
  };

  updateProductionOrder = async () => {
    const { t, selectedOrder } = this.props;
    const { products } = this.state;
    try {
      this.setState({ loading: true });

      const res = await instance.post(`update_production_order/`, {
        orderId: selectedOrder.id,
        products: products,
      });

      await this.fetchProductionOrderDetails();
      this.setState({
        loading: false,
        editMode: false,
      });
      message.success(t("Changed successfully"));
    } catch (err) {
      this.setState({
        loading: false,
      });
      if (err.response && err.response.status == 403)
        message.error(t("AccessDeniedMessage"));
      else message.error(t("SomethingWentWrong"));
    }
  };
  setEditMode = (newEditMode) => {
    this.setState({ editMode: newEditMode });
  };
  setProducts = (newProducts) => {
    this.setState({ products: newProducts });
  };
  updateProductionOrderStatus = async (newStatus) => {
    const { t, selectedOrder } = this.props;
    const { products } = this.state;
    try {
      this.setState({ loading: true });

      const res = await instance.post(`change_production_order_status/`, {
        oid: selectedOrder.id,
        newStatus: newStatus,
        type: "status",
      });
      selectedOrder.status = newStatus;
      message.success(t("Changed successfully"));

      this.setState({
        loading: false,
      });
    } catch (err) {
      this.setState({
        loading: false,
      });
      if (err.response && err.response.status == 403)
        message.error(t("AccessDeniedMessage"));
      else message.error(err.response?.data?.error || t("SomethingWentWrong"));
    }
  };
  componentDidMount = () => {
    this.fetchProductionOrderDetails();
  };
  render() {
    const { t, config, selectedOrder, permissions, isViewOnly } = this.props;
    const { loading, products, editMode, originalProducts } = this.state;

    return (
      <Modal
        maskClosable={false}
        destroyOnClose={true}
        title={
          <div
            className="ant-modal-title"
            style={{ textAlign: config.direction == "rtl" ? "right" : "left" }}
          >
            {t("Order details")}
          </div>
        }
        open={true}
        bodyStyle={{
          paddingTop: 0,
          width: "auto",
          textAlign: config.direction == "ltr" ? "left" : "right",
        }}
        width={580}
        onCancel={this.props.onClose}
        footer={[
          !loading && !isViewOnly && (
            <>
              {!editMode ? (
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  {permissions.can_create_production_orders && (
                    <Button
                      onClick={() =>
                        this.props.duplicateOrder({
                          products: products,
                          order: selectedOrder,
                        })
                      }
                      style={{
                        margin: 5,
                      }}
                    >
                      {t("Duplicate Production")}
                    </Button>
                  )}
                  {selectedOrder.status == "New" && (
                    <div>
                      {permissions.can_update_production_orders && (
                        <Button
                          type="danger"
                          onClick={() =>
                            this.updateProductionOrderStatus("Cancelled")
                          }
                          style={{ margin: "5px" }}
                        >
                          {t("Cancel")}
                        </Button>
                      )}
                      {permissions.can_complete_production_orders && (
                        <Button
                          type="primary"
                          onClick={() =>
                            this.updateProductionOrderStatus("Complete")
                          }
                          style={{ margin: "5px" }}
                        >
                          {t("Complete")}
                        </Button>
                      )}
                    </div>
                  )}
                </div>
              ) : (
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Button
                    type="danger"
                    onClick={() => {
                      this.setState({
                        products: originalProducts,
                      });
                      this.setEditMode(false);
                    }}
                    style={{
                      margin: 5,
                    }}
                  >
                    {t("Cancel Updates")}
                  </Button>

                  <Button
                    type="primary"
                    onClick={() => this.updateProductionOrder()}
                    style={{ margin: "5px" }}
                  >
                    {t("Update")}
                  </Button>
                </div>
              )}
            </>
          ),
        ]}
      >
        {loading ? (
          <div className="my-5 text-center">
            <Spin indicator={antIcon} />
          </div>
        ) : (
          <ProductionOrderInvoice
            selectedOrder={selectedOrder}
            products={products}
            editMode={editMode}
            setEditMode={this.setEditMode}
            setProducts={this.setProducts}
            isViewOnly={isViewOnly}
            fetchProductionOrderDetails={this.fetchProductionOrderDetails}
          />
        )}
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    permissions: state.auth.permissions,
    settings: state.auth.settings,
    config: state.config,
    is_staff: state.auth.is_staff,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withNamespaces()(ProductionOrderDetailsModal));
